<div class="modal-header itd-header">
  <h4 class="modal-title header-5">How would you like to import test Data?</h4>
  <button type="button" class="accello-icon-btn" (click)="cancel()" aria-label="Close">
    <img src="assets/images/virtusa-icons/close.svg" alt="Close" />
  </button>
</div>

<div class="modal-body itd-body">
  <div class="info-box">
    <div class="d-flex gap-2 align-items-center mb-1">
      <div class="info-box-icon-wrap">
        <img
          class="info-box-icon"
          src="assets/images/virtusa-icons/bulb.svg"
          alt=""
          width="16"
          height="16"
        />
      </div>
      <span class="info-box-title">Recommended Actions</span>
    </div>
    <p class="info-box-body mb-0">
      Upload an Excel file (<strong>.xlsx</strong> or <strong>.xls</strong>) to
      import test data for the selected suite and test cases.
    </p>
  </div>

  <div class="itd-fields-row">
    <div class="itd-field">
      <div class="itd-label-row">
        <label class="itd-label mb-0" for="itd-test-suite">
          Test Suite <span class="itd-required">*</span>
        </label>
        @if (isLoadingSuites) {
          <span
            class="spinner-border spinner-border-sm itd-label-spinner"
            role="status"
            aria-label="Loading test suites"
          ></span>
        }
      </div>
      <div class="itd-select-wrap">
        <select
          id="itd-test-suite"
          class="itd-select form-select"
          [(ngModel)]="selectedSuiteId"
          (ngModelChange)="onSuiteChange()"
          [disabled]="isLoadingSuites"
        >
          <option value="" disabled hidden>Select test suite</option>
          <option *ngFor="let suite of testSuites" [value]="suite._id">
            {{ suite.versionName || suite.name }}
          </option>
        </select>
        <img
          class="itd-select-arrow"
          src="assets/images/virtusa-icons/drop-arrow.svg"
          alt=""
          aria-hidden="true"
          width="12"
          height="8"
        />
      </div>
      @if (suitesError) {
        <p class="itd-field-error">Failed to load test suites.</p>
      }
    </div>

    <div class="itd-field">
      <div class="itd-label-row">
        <label class="itd-label mb-0">Test Case</label>
        @if (isLoadingTestCases) {
          <span
            class="spinner-border spinner-border-sm itd-label-spinner"
            role="status"
            aria-label="Loading test cases"
          ></span>
        }
      </div>
      <div class="itd-multiselect" (click)="$event.stopPropagation()">
        <button
          type="button"
          class="itd-multiselect-trigger"
          [class.open]="isTestCaseDropdownOpen"
          [class.inactive]="!selectedSuiteId && !isLoadingTestCases"
          [class.loading]="isLoadingTestCases"
          (click)="toggleTestCaseDropdown($event)"
        >
          <span
            class="itd-multiselect-value"
            [class.placeholder]="selectedTestCaseIds.size === 0 || !selectedSuiteId"
          >
            {{ testCaseDropdownLabel }}
          </span>
          <i
            class="bi"
            [class.bi-chevron-up]="isTestCaseDropdownOpen"
            [class.bi-chevron-down]="!isTestCaseDropdownOpen"
          ></i>
        </button>

        @if (isTestCaseDropdownOpen) {
          <div class="itd-multiselect-panel">
            <label
              class="itd-multiselect-option itd-multiselect-all"
              (click)="toggleAllTestCases($event)"
            >
              <span
                class="itd-checkbox"
                [class.checked]="isAllTestCasesSelected"
                [class.indeterminate]="isSomeTestCasesSelected"
              >
                @if (isAllTestCasesSelected) {
                  <i class="bi bi-check-lg"></i>
                } @else if (isSomeTestCasesSelected) {
                  <i class="bi bi-dash-lg"></i>
                }
              </span>
              <span class="itd-option-label">All</span>
            </label>

            <div class="itd-multiselect-divider"></div>

            @for (tc of testCaseOptions; track tc._id) {
              <label class="itd-multiselect-option" (click)="toggleTestCase($event, tc._id)">
                <span class="itd-checkbox" [class.checked]="isTestCaseSelected(tc._id)">
                  @if (isTestCaseSelected(tc._id)) {
                    <i class="bi bi-check-lg"></i>
                  }
                </span>
                <span class="itd-option-label">{{ tc.testCaseId }}</span>
              </label>
            }
          </div>
        }
      </div>
      @if (testCasesError) {
        <p class="itd-field-error">Failed to load test cases.</p>
      }
    </div>
  </div>

  @if (selectedTestCaseCount > 0) {
    <div class="itd-selected-section">
      <span class="itd-selected-label">
        Selected Test Case ({{ selectedTestCaseCount }})
      </span>
      <div class="itd-chips-row">
        @for (tc of visibleSelectedTestCases; track tc._id) {
          <span class="itd-chip">
            <span class="itd-chip-text">{{ tc.testCaseId }}</span>
            <button
              type="button"
              class="itd-chip-remove"
              (click)="removeTestCase(tc._id, $event)"
              [attr.aria-label]="'Remove ' + tc.testCaseId"
            >
              <img src="assets/images/virtusa-icons/close.svg" alt="" width="12" height="12" />
            </button>
          </span>
        }
        @if (overflowTestCaseCount > 0) {
          <span class="itd-chip itd-chip-more">+{{ overflowTestCaseCount }} More</span>
        }
      </div>
    </div>
  }

  <div class="itd-inline-form">
    <div class="itd-inline-form-header">
      <span class="itd-label mb-0">
        Import Test Data File <span class="itd-required">*</span>
      </span>
    </div>

    <div
      class="itd-file-upload-area"
      [class.drag-over]="isDragOver"
      (drop)="onDrop($event)"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
    >
      <img
        class="itd-upload-icon"
        src="assets/images/virtusa-icons/upload-light.svg"
        alt=""
        width="24"
        height="24"
      />
      <div class="itd-upload-text">
        Drag &amp; drop your file here
        <label class="itd-file-chooser">
          or Choose file
          <input
            type="file"
            [accept]="newFileAccept"
            (change)="onNewFileSelected($event)"
            hidden
          />
        </label>
      </div>
      @if (newFile) {
        <div class="itd-selected-file">{{ newFile.name }}</div>
      }
    </div>

    @if (uploadError) {
      <p class="itd-field-error">{{ uploadError }}</p>
    }
  </div>
</div>

<div class="modal-footer itd-footer">
  <div class="itd-footer-actions ms-auto">
    <button type="button" class="btn-accello-secondary" (click)="cancel()" [disabled]="isSubmitting">
      Cancel
    </button>
    <button
      type="button"
      class="btn-accello-primary-light d-inline-flex align-items-center gap-2"
      [disabled]="!canAdd"
      (click)="add()"
    >
      @if (isSubmitting) {
        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
        Adding…
      } @else {
        Add
      }
    </button>
  </div>
</div>
